import { createApi } from "@reduxjs/toolkit/query/react";
import { baseApiQuery } from "../../../shared/api";
import { BaseResponse } from "../../../shared/types";
import {
  CompetenciesResponse,
  CompetencyResponse,
  CreateCompetencyRequest,
  UpdateCompetencyRequest,
} from "./types";

export const adminCompetencyApi = createApi({
  reducerPath: "adminCompetencyApi",
  baseQuery: baseApiQuery,
  tagTypes: ["Competencies"],
  endpoints: (builder) => ({
    getCompetencies: builder.query<CompetenciesResponse, void>({
      query: () => "/admin/competencies",
      providesTags: ["Competencies"],
    }),

    createCompetency: builder.mutation<
      CompetencyResponse,
      CreateCompetencyRequest
    >({
      query: (body) => ({
        url: "/admin/competencies",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Competencies"],
    }),

    updateCompetency: builder.mutation<
      CompetencyResponse,
      { id: number; body: UpdateCompetencyRequest }
    >({
      query: ({ id, body }) => ({
        url: `/admin/competencies/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["Competencies"],
    }),

    deleteCompetency: builder.mutation<BaseResponse, number>({
      query: (id) => ({
        url: `/admin/competencies/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Competencies"],
    }),
  }),
});

export const {
  useGetCompetenciesQuery,
  useCreateCompetencyMutation,
  useUpdateCompetencyMutation,
  useDeleteCompetencyMutation,
} = adminCompetencyApi;
